/**
 * A promotion's link is either a site-relative path (`/koledna-igra-s-nagradi/`)
 * or a full external URL — never a bare domain or relative fragment, which
 * would silently 404 or resolve against the wrong host.
 */
export const isValidLink = (link) =>
  typeof link === "string" && (link.startsWith("/") || link.startsWith("https://"));
